/**
 * International Bank Account Number (IBAN)
 * Based on IBANTools is TypeScript/JavaScript library for validation, creation and extraction of IBAN, BBAN and BIC/SWIFT numbers.
 */
import { AbstractControl } from '@angular/forms';
import * as ibantools from 'ibantools';

export function validateIBAN(control: AbstractControl): { iban: string } {
  const valueIsValid = ibantools.isValidIBAN(control.value);
  return (valueIsValid) ? null : {iban: 'Invalid IBAN number'};
}
